import * as React from 'react';

import { createIcon } from '../Icon';
export const CheckIcon = createIcon(
  <polyline points="20 6 9 17 4 12" />,
  'CheckIcon'
);
